module.exports = "/assets/side-events-hero.png?k0a/AXD";